<template lang="pug">
  partnerBoard(:which="which")
</template>
<script>
import partnerBoard from '../components/partnerBoard.vue';
export default {
  data () {
    return {
      which: {
        type: 'partner',
      }
    };
  },
  components: {
    partnerBoard
  }
};
</script>
<style lang="sass" scoped>
</style>
